import {
  // Real Estate & Buildings
  House,
  HouseLine,
  HouseSimple,
  Building,
  Buildings,
  BuildingOffice,
  Warehouse,
  Storefront,
  Bank,
  Factory,
  Hospital,
  Church,
  Garage,
  Door,
  DoorOpen,
  Stairs,
  Elevator,
  Wall,
  Park,
  SwimmingPool,
  Lighthouse,
  CraneTower,
  // Infrastructure
  Blueprint,
  MapTrifold,
  MapPin,
  Compass,
  Path,
  Columns,
  // Voorzieningen & Toestellen (Assets & Appliances)
  FireExtinguisher,
  Alarm,
  BellRinging,
  Flame,
  ThermometerHot,
  ThermometerSimple,
  Gauge,
  Speedometer,
  Oven,
  WashingMachine,
  Engine,
  Nut,
  GearSix,
  GearFine,
  ToggleLeft,
  BatteryCharging,
  BatteryFull,
  BatteryWarning,
  Cpu,
  Circuitry,
  SquaresFour,
  GridFour,
  Mailbox,
  GasPump,
  CallBell,
  SolarRoof,
  Lockers,
  Ladder,
  LadderSimple,
  HardHat,
  TrafficSignal,
  Radioactive,
  // Technical & Utilities
  Fire,
  Lightning,
  LightningSlash,
  Plug,
  PlugCharging,
  Plugs,
  PlugsConnected,
  Drop,
  DropSlash,
  DropHalf,
  Pipe,
  PipeWrench,
  Snowflake,
  Thermometer,
  ThermometerCold,
  Fan,
  Sun,
  SolarPanel,
  Wind,
  Lightbulb,
  LightbulbFilament,
  Lamp,
  LampPendant,
  Broadcast,
  WifiHigh,
  WifiSlash,
  WifiLow,
  CellTower,
  CellSignalFull,
  // Safety & Security
  ShieldCheck,
  ShieldWarning,
  Shield,
  Lock,
  LockOpen,
  LockKey,
  LockLaminated,
  Key,
  Eye,
  Warning,
  WarningCircle,
  WarningOctagon,
  WarningDiamond,
  Skull,
  Siren,
  FirstAid,
  Fingerprint,
  FingerprintSimple,
  VideoCamera,
  Webcam,
  Detective,
  Binoculars,
  PersonSimpleWalk,
  PersonArmsSpread,
  Prohibit,
  Cross,
  SealCheck,
  SealWarning,
  // Tools & Maintenance
  Wrench,
  Hammer,
  Screwdriver,
  Toolbox,
  Gear,
  Faders,
  PaintRoller,
  PaintBrush,
  PaintBrushHousehold,
  PaintBucket,
  Broom,
  HandSoap,
  ArrowsClockwise,
  // Nature & Environment
  Leaf,
  Tree,
  Plant,
  PottedPlant,
  Flower,
  Recycle,
  Globe,
  Mountains,
  Waves,
  CloudRain,
  CloudSun,
  CloudLightning,
  CloudWarning,
  Umbrella,
  // Furniture & Interior
  Armchair,
  Chair,
  OfficeChair,
  Couch,
  Desk,
  Dresser,
  Bed,
  Bathtub,
  Toilet,
  ToiletPaper,
  Shower,
  CookingPot,
  // Measurements & Documents
  Ruler,
  Stack,
  Certificate,
  FileText,
  FileLock,
  Notebook,
  Calculator,
  ChartLine,
  ChartBar,
  Scales,
  TreeStructure,
  Database,
  HardDrive,
  HardDrives,
  // Transport
  Car,
  Truck,
  Bicycle,
  Train,
  Airplane,
  Boat,
  Motorcycle,
  FireTruck,
  // People & Communication
  Users,
  User,
  Handshake,
  Phone,
  PhoneCall,
  Envelope,
  ChatCircle,
  Bell,
  BellSimple,
  BellSlash,
  Megaphone,
  Microphone,
  SpeakerHigh,
  // Time & Calendar
  Clock,
  ClockCountdown,
  Calendar,
  Hourglass,
  Timer,
  // Health & Medical
  Heartbeat,
  Heart,
  Pill,
  Stethoscope,
  Syringe,
  Bandaids,
  Wheelchair,
  // Science & Education
  Atom,
  Flask,
  TestTube,
  Microscope,
  GraduationCap,
  BookOpen,
  // Business & Finance
  Money,
  CurrencyEur,
  CreditCard,
  Wallet,
  PiggyBank,
  Receipt,
  TrendUp,
  Percent,
  // Devices & IT
  Desktop,
  DesktopTower,
  ComputerTower,
  Monitor,
  Printer,
  DeviceMobile,
  DeviceTablet,
  Keyboard,
  Mouse,
  Bluetooth,
  // Media & Entertainment
  Camera,
  MusicNote,
  Headphones,
  Television,
  GameController,
  // Misc
  Diamond,
  Star,
  Flag,
  Trophy,
  Target,
  Cube,
  PuzzlePiece,
  Tag,
  Bookmark,
  Archive,
  Package,
  Gift,
  Barcode,
  QrCode,
  Check,
  X,
  Info,
  ClipboardText,
  Scan,
  Tray,
  Funnel,
  Spinner,
} from '@phosphor-icons/react';
import type { Icon as PhosphorIcon } from '@phosphor-icons/react';

export interface IconItem {
  value: string;
  label: string;
  Icon: PhosphorIcon;
}

export interface IconCategory {
  key: string;
  label: string;
  icons: IconItem[];
}

// ── Voorzieningen & Toestellen (primary for asset types) ──

export const ASSET_ICONS: IconItem[] = [
  // Fire safety
  { value: 'FireExtinguisher', label: 'Brandblusser', Icon: FireExtinguisher },
  { value: 'Alarm', label: 'Rookmelder', Icon: Alarm },
  { value: 'BellRinging', label: 'Brandalarm', Icon: BellRinging },
  { value: 'Fire', label: 'Brandveiligheid', Icon: Fire },
  { value: 'Siren', label: 'Sirene/Alarm', Icon: Siren },
  { value: 'FireTruck', label: 'Brandweer', Icon: FireTruck },
  // Heating & HVAC
  { value: 'Flame', label: 'Ketel/Boiler', Icon: Flame },
  { value: 'ThermometerHot', label: 'Verwarming', Icon: ThermometerHot },
  { value: 'Thermometer', label: 'Thermostaat', Icon: Thermometer },
  { value: 'ThermometerSimple', label: 'Temperatuursensor', Icon: ThermometerSimple },
  { value: 'ThermometerCold', label: 'Koeling', Icon: ThermometerCold },
  { value: 'Snowflake', label: 'Airco/Klimaat', Icon: Snowflake },
  { value: 'Fan', label: 'Ventilatie', Icon: Fan },
  // Plumbing & water
  { value: 'Drop', label: 'Watervoorziening', Icon: Drop },
  { value: 'DropSlash', label: 'Waterafsluiter', Icon: DropSlash },
  { value: 'DropHalf', label: 'Waterreservoir', Icon: DropHalf },
  { value: 'Pipe', label: 'Leidingen', Icon: Pipe },
  { value: 'PipeWrench', label: 'Sanitair', Icon: PipeWrench },
  { value: 'Shower', label: 'Douche', Icon: Shower },
  { value: 'Bathtub', label: 'Bad', Icon: Bathtub },
  { value: 'Toilet', label: 'Toilet', Icon: Toilet },
  { value: 'HandSoap', label: 'Wasbak/Dispenser', Icon: HandSoap },
  // Electrical
  { value: 'Lightning', label: 'Elektriciteit', Icon: Lightning },
  { value: 'LightningSlash', label: 'Stroomonderbreker', Icon: LightningSlash },
  { value: 'Plug', label: 'Stopcontact', Icon: Plug },
  { value: 'PlugCharging', label: 'Laadpunt', Icon: PlugCharging },
  { value: 'Plugs', label: 'Aansluitingen', Icon: Plugs },
  { value: 'PlugsConnected', label: 'Aangesloten', Icon: PlugsConnected },
  { value: 'ToggleLeft', label: 'Schakelaar', Icon: ToggleLeft },
  { value: 'GridFour', label: 'Groepenkast', Icon: GridFour },
  { value: 'Circuitry', label: 'Bekabeling', Icon: Circuitry },
  // Meters & gauges
  { value: 'Gauge', label: 'Meter', Icon: Gauge },
  { value: 'Speedometer', label: 'Debietmeter', Icon: Speedometer },
  // Energy & solar
  { value: 'Sun', label: 'Zonne-energie', Icon: Sun },
  { value: 'SolarPanel', label: 'Zonnepaneel', Icon: SolarPanel },
  { value: 'SolarRoof', label: 'Zonnedak', Icon: SolarRoof },
  { value: 'BatteryCharging', label: 'Thuisbatterij', Icon: BatteryCharging },
  { value: 'BatteryFull', label: 'Batterij', Icon: BatteryFull },
  { value: 'BatteryWarning', label: 'Batterij waarschuwing', Icon: BatteryWarning },
  { value: 'Wind', label: 'Windenergie', Icon: Wind },
  // Lighting
  { value: 'Lightbulb', label: 'Verlichting', Icon: Lightbulb },
  { value: 'LightbulbFilament', label: 'Gloeilamp', Icon: LightbulbFilament },
  { value: 'Lamp', label: 'Bureaulamp', Icon: Lamp },
  { value: 'LampPendant', label: 'Hanglamp', Icon: LampPendant },
  // Appliances
  { value: 'Oven', label: 'Oven/Fornuis', Icon: Oven },
  { value: 'CookingPot', label: 'Kookplaat', Icon: CookingPot },
  { value: 'WashingMachine', label: 'Wasmachine', Icon: WashingMachine },
  { value: 'Television', label: 'TV/Scherm', Icon: Television },
  // Motors & machinery
  { value: 'Engine', label: 'Motor/Pomp', Icon: Engine },
  { value: 'GearSix', label: 'Tandwiel', Icon: GearSix },
  { value: 'GearFine', label: 'Mechanisme', Icon: GearFine },
  { value: 'Nut', label: 'Bevestiging', Icon: Nut },
  { value: 'Spinner', label: 'Draaiend onderdeel', Icon: Spinner },
  // Network & communication
  { value: 'WifiHigh', label: 'WiFi router', Icon: WifiHigh },
  { value: 'WifiSlash', label: 'Geen WiFi', Icon: WifiSlash },
  { value: 'Broadcast', label: 'Antenne', Icon: Broadcast },
  { value: 'CellTower', label: 'Zendmast', Icon: CellTower },
  { value: 'Bluetooth', label: 'Bluetooth', Icon: Bluetooth },
  // Security devices
  { value: 'VideoCamera', label: 'Bewakingscamera', Icon: VideoCamera },
  { value: 'Webcam', label: 'IP Camera', Icon: Webcam },
  { value: 'Lock', label: 'Slot', Icon: Lock },
  { value: 'LockKey', label: 'Sleutelslot', Icon: LockKey },
  { value: 'LockLaminated', label: 'Veiligheidsslot', Icon: LockLaminated },
  { value: 'Fingerprint', label: 'Vingerafdruklezer', Icon: Fingerprint },
  { value: 'PersonSimpleWalk', label: 'Bewegingsmelder', Icon: PersonSimpleWalk },
  { value: 'SpeakerHigh', label: 'Luidspreker', Icon: SpeakerHigh },
  { value: 'Microphone', label: 'Intercom', Icon: Microphone },
  { value: 'CallBell', label: 'Deurbel', Icon: CallBell },
  // Building structure
  { value: 'Door', label: 'Deur', Icon: Door },
  { value: 'DoorOpen', label: 'Toegangsdeur', Icon: DoorOpen },
  { value: 'Elevator', label: 'Lift', Icon: Elevator },
  { value: 'Stairs', label: 'Trap', Icon: Stairs },
  { value: 'Wall', label: 'Muur/Wand', Icon: Wall },
  { value: 'Columns', label: 'Draagstructuur', Icon: Columns },
  { value: 'Ladder', label: 'Ladder', Icon: Ladder },
  { value: 'Garage', label: 'Garagepoort', Icon: Garage },
  // Outdoor / grounds
  { value: 'GasPump', label: 'Gasaansluiting', Icon: GasPump },
  { value: 'Mailbox', label: 'Brievenbus', Icon: Mailbox },
  { value: 'Lockers', label: 'Lockers/Berging', Icon: Lockers },
  { value: 'SwimmingPool', label: 'Zwembad', Icon: SwimmingPool },
  { value: 'Park', label: 'Tuin/Park', Icon: Park },
  { value: 'TrafficSignal', label: 'Slagboom/Signaal', Icon: TrafficSignal },
  // Safety equipment
  { value: 'HardHat', label: 'Veiligheidshelm', Icon: HardHat },
  { value: 'FirstAid', label: 'EHBO-kit', Icon: FirstAid },
  { value: 'Radioactive', label: 'Gevaarlijke stof', Icon: Radioactive },
  // IT infrastructure
  { value: 'Cpu', label: 'Server/CPU', Icon: Cpu },
  { value: 'HardDrive', label: 'NAS/Opslag', Icon: HardDrive },
  { value: 'Printer', label: 'Printer', Icon: Printer },
  { value: 'Monitor', label: 'Beeldscherm', Icon: Monitor },
  { value: 'Desktop', label: 'Computer', Icon: Desktop },
];

// ── Real Estate & Buildings ──

export const REAL_ESTATE_ICONS: IconItem[] = [
  { value: 'House', label: 'Woning', Icon: House },
  { value: 'HouseLine', label: 'Huis met lijn', Icon: HouseLine },
  { value: 'HouseSimple', label: 'Simpel huis', Icon: HouseSimple },
  { value: 'Building', label: 'Gebouw', Icon: Building },
  { value: 'Buildings', label: 'Gebouwen', Icon: Buildings },
  { value: 'BuildingOffice', label: 'Kantoor', Icon: BuildingOffice },
  { value: 'Warehouse', label: 'Magazijn', Icon: Warehouse },
  { value: 'Storefront', label: 'Winkel', Icon: Storefront },
  { value: 'Bank', label: 'Bank', Icon: Bank },
  { value: 'Factory', label: 'Fabriek', Icon: Factory },
  { value: 'Hospital', label: 'Ziekenhuis', Icon: Hospital },
  { value: 'Church', label: 'Kerk', Icon: Church },
  { value: 'Garage', label: 'Garage', Icon: Garage },
  { value: 'Door', label: 'Deur', Icon: Door },
  { value: 'DoorOpen', label: 'Open deur', Icon: DoorOpen },
  { value: 'Stairs', label: 'Trap', Icon: Stairs },
  { value: 'Elevator', label: 'Lift', Icon: Elevator },
  { value: 'Wall', label: 'Muur', Icon: Wall },
  { value: 'Columns', label: 'Kolommen', Icon: Columns },
  { value: 'CraneTower', label: 'Bouwkraan', Icon: CraneTower },
  { value: 'Lighthouse', label: 'Vuurtoren', Icon: Lighthouse },
  { value: 'SwimmingPool', label: 'Zwembad', Icon: SwimmingPool },
  { value: 'Park', label: 'Park/Tuin', Icon: Park },
  { value: 'Blueprint', label: 'Plannen', Icon: Blueprint },
  { value: 'MapTrifold', label: 'Kadaster', Icon: MapTrifold },
  { value: 'MapPin', label: 'Locatie', Icon: MapPin },
  { value: 'Compass', label: 'Kompas', Icon: Compass },
  { value: 'Path', label: 'Pad/Weg', Icon: Path },
  { value: 'Stack', label: 'Bodem/Lagen', Icon: Stack },
  { value: 'Diamond', label: 'Erfdienstbaarheid', Icon: Diamond },
  { value: 'Ruler', label: 'Opmeting', Icon: Ruler },
  { value: 'Certificate', label: 'Certificaat', Icon: Certificate },
];

// ── Technisch & Installaties ──

export const TECHNICAL_ICONS: IconItem[] = [
  { value: 'Fire', label: 'Brandveiligheid', Icon: Fire },
  { value: 'FireExtinguisher', label: 'Brandblusser', Icon: FireExtinguisher },
  { value: 'Lightning', label: 'Elektriciteit', Icon: Lightning },
  { value: 'LightningSlash', label: 'Stroomonderbreker', Icon: LightningSlash },
  { value: 'Plug', label: 'Stekker', Icon: Plug },
  { value: 'PlugCharging', label: 'Laadpunt', Icon: PlugCharging },
  { value: 'Plugs', label: 'Aansluitingen', Icon: Plugs },
  { value: 'PlugsConnected', label: 'Aangesloten', Icon: PlugsConnected },
  { value: 'Drop', label: 'Water', Icon: Drop },
  { value: 'DropSlash', label: 'Waterafsluiter', Icon: DropSlash },
  { value: 'Pipe', label: 'Leidingen', Icon: Pipe },
  { value: 'PipeWrench', label: 'Sanitair', Icon: PipeWrench },
  { value: 'Snowflake', label: 'Klimatisatie', Icon: Snowflake },
  { value: 'Thermometer', label: 'Temperatuur', Icon: Thermometer },
  { value: 'ThermometerHot', label: 'Verwarming', Icon: ThermometerHot },
  { value: 'ThermometerCold', label: 'Koeling', Icon: ThermometerCold },
  { value: 'Fan', label: 'Ventilatie', Icon: Fan },
  { value: 'Sun', label: 'Zonne-energie', Icon: Sun },
  { value: 'SolarPanel', label: 'Zonnepaneel', Icon: SolarPanel },
  { value: 'SolarRoof', label: 'Zonnedak', Icon: SolarRoof },
  { value: 'Wind', label: 'Wind', Icon: Wind },
  { value: 'Lightbulb', label: 'Verlichting', Icon: Lightbulb },
  { value: 'LightbulbFilament', label: 'Gloeilamp', Icon: LightbulbFilament },
  { value: 'Lamp', label: 'Lamp', Icon: Lamp },
  { value: 'LampPendant', label: 'Hanglamp', Icon: LampPendant },
  { value: 'Broadcast', label: 'Netwerk/Uitzending', Icon: Broadcast },
  { value: 'WifiHigh', label: 'WiFi', Icon: WifiHigh },
  { value: 'WifiSlash', label: 'Geen WiFi', Icon: WifiSlash },
  { value: 'WifiLow', label: 'Zwak WiFi', Icon: WifiLow },
  { value: 'CellTower', label: 'Zendmast', Icon: CellTower },
  { value: 'CellSignalFull', label: 'Signaal', Icon: CellSignalFull },
  { value: 'Circuitry', label: 'Bekabeling', Icon: Circuitry },
  { value: 'Gear', label: 'Technisch', Icon: Gear },
  { value: 'GearSix', label: 'Tandwiel', Icon: GearSix },
  { value: 'Engine', label: 'Motor/Pomp', Icon: Engine },
  { value: 'Gauge', label: 'Meter', Icon: Gauge },
  { value: 'Speedometer', label: 'Debietmeter', Icon: Speedometer },
  { value: 'BatteryCharging', label: 'Batterij laden', Icon: BatteryCharging },
  { value: 'BatteryFull', label: 'Batterij vol', Icon: BatteryFull },
  { value: 'Cpu', label: 'Processor/Besturing', Icon: Cpu },
  { value: 'Cube', label: 'Toestellen', Icon: Cube },
  { value: 'GasPump', label: 'Gasaansluiting', Icon: GasPump },
  { value: 'Flame', label: 'Ketel/Boiler', Icon: Flame },
  { value: 'Alarm', label: 'Rookmelder', Icon: Alarm },
  { value: 'BellRinging', label: 'Brandalarm', Icon: BellRinging },
];

// ── Veiligheid & Beveiliging ──

export const SAFETY_ICONS: IconItem[] = [
  { value: 'ShieldCheck', label: 'Veiligheid', Icon: ShieldCheck },
  { value: 'ShieldWarning', label: 'Waarschuwing schild', Icon: ShieldWarning },
  { value: 'Shield', label: 'Schild', Icon: Shield },
  { value: 'Lock', label: 'Slot', Icon: Lock },
  { value: 'LockOpen', label: 'Open slot', Icon: LockOpen },
  { value: 'LockKey', label: 'Sleutelslot', Icon: LockKey },
  { value: 'LockLaminated', label: 'Veiligheidsslot', Icon: LockLaminated },
  { value: 'Key', label: 'Sleutel', Icon: Key },
  { value: 'Eye', label: 'Inspectie', Icon: Eye },
  { value: 'Warning', label: 'Waarschuwing', Icon: Warning },
  { value: 'WarningCircle', label: 'Waarschuwing cirkel', Icon: WarningCircle },
  { value: 'WarningOctagon', label: 'Noodstop', Icon: WarningOctagon },
  { value: 'WarningDiamond', label: 'Gevaarsteken', Icon: WarningDiamond },
  { value: 'Skull', label: 'Gevaarlijk', Icon: Skull },
  { value: 'Siren', label: 'Sirene', Icon: Siren },
  { value: 'FirstAid', label: 'EHBO', Icon: FirstAid },
  { value: 'Fingerprint', label: 'Vingerafdruk', Icon: Fingerprint },
  { value: 'FingerprintSimple', label: 'Biometrisch', Icon: FingerprintSimple },
  { value: 'VideoCamera', label: 'Bewakingscamera', Icon: VideoCamera },
  { value: 'Webcam', label: 'IP Camera', Icon: Webcam },
  { value: 'Detective', label: 'Detectie', Icon: Detective },
  { value: 'Binoculars', label: 'Observatie', Icon: Binoculars },
  { value: 'PersonSimpleWalk', label: 'Bewegingsmelder', Icon: PersonSimpleWalk },
  { value: 'PersonArmsSpread', label: 'Toegangscontrole', Icon: PersonArmsSpread },
  { value: 'Prohibit', label: 'Verboden', Icon: Prohibit },
  { value: 'Cross', label: 'Nooduitgang', Icon: Cross },
  { value: 'SealCheck', label: 'Keuringsmerk', Icon: SealCheck },
  { value: 'SealWarning', label: 'Keuringswaarschuwing', Icon: SealWarning },
  { value: 'HardHat', label: 'Veiligheidshelm', Icon: HardHat },
  { value: 'Radioactive', label: 'Gevaarlijke stof', Icon: Radioactive },
  { value: 'TrafficSignal', label: 'Verkeerslicht', Icon: TrafficSignal },
];

// ── Milieu & Natuur ──

export const ENVIRONMENT_ICONS: IconItem[] = [
  { value: 'Leaf', label: 'Energie/Milieu', Icon: Leaf },
  { value: 'Tree', label: 'Boom', Icon: Tree },
  { value: 'Plant', label: 'Plant', Icon: Plant },
  { value: 'PottedPlant', label: 'Potplant', Icon: PottedPlant },
  { value: 'Flower', label: 'Bloem', Icon: Flower },
  { value: 'Recycle', label: 'Recyclen', Icon: Recycle },
  { value: 'Globe', label: 'Wereld', Icon: Globe },
  { value: 'Mountains', label: 'Bergen', Icon: Mountains },
  { value: 'Waves', label: 'Golven', Icon: Waves },
  { value: 'CloudRain', label: 'Regen', Icon: CloudRain },
  { value: 'CloudSun', label: 'Weer', Icon: CloudSun },
  { value: 'CloudLightning', label: 'Onweer', Icon: CloudLightning },
  { value: 'CloudWarning', label: 'Weerwaarschuwing', Icon: CloudWarning },
  { value: 'Umbrella', label: 'Paraplu', Icon: Umbrella },
];

// ── Gereedschap & Onderhoud ──

export const TOOLS_ICONS: IconItem[] = [
  { value: 'Wrench', label: 'Onderhoud', Icon: Wrench },
  { value: 'Hammer', label: 'Renovatie', Icon: Hammer },
  { value: 'Screwdriver', label: 'Schroevendraaier', Icon: Screwdriver },
  { value: 'Toolbox', label: 'Gereedschap', Icon: Toolbox },
  { value: 'Faders', label: 'Instellingen', Icon: Faders },
  { value: 'PaintRoller', label: 'Verfroller', Icon: PaintRoller },
  { value: 'PaintBrush', label: 'Verfkwast', Icon: PaintBrush },
  { value: 'PaintBrushHousehold', label: 'Schilderskwast', Icon: PaintBrushHousehold },
  { value: 'PaintBucket', label: 'Verfemmer', Icon: PaintBucket },
  { value: 'Broom', label: 'Bezem', Icon: Broom },
  { value: 'HandSoap', label: 'Schoonmaakmiddel', Icon: HandSoap },
  { value: 'Ladder', label: 'Ladder', Icon: Ladder },
  { value: 'LadderSimple', label: 'Trapladder', Icon: LadderSimple },
  { value: 'ArrowsClockwise', label: 'Circulatie/Onderhoud', Icon: ArrowsClockwise },
  { value: 'Scan', label: 'Scannen/Inspectie', Icon: Scan },
];

// ── Interieur & Meubelen ──

export const INTERIOR_ICONS: IconItem[] = [
  { value: 'Armchair', label: 'Fauteuil', Icon: Armchair },
  { value: 'Chair', label: 'Stoel', Icon: Chair },
  { value: 'OfficeChair', label: 'Bureaustoel', Icon: OfficeChair },
  { value: 'Couch', label: 'Bank/Sofa', Icon: Couch },
  { value: 'Desk', label: 'Bureau', Icon: Desk },
  { value: 'Dresser', label: 'Kast/Dressoir', Icon: Dresser },
  { value: 'Bed', label: 'Bed', Icon: Bed },
  { value: 'Bathtub', label: 'Bad', Icon: Bathtub },
  { value: 'Toilet', label: 'Toilet', Icon: Toilet },
  { value: 'ToiletPaper', label: 'Toiletpapier', Icon: ToiletPaper },
  { value: 'Shower', label: 'Douche', Icon: Shower },
  { value: 'CookingPot', label: 'Keuken', Icon: CookingPot },
  { value: 'Oven', label: 'Oven', Icon: Oven },
  { value: 'WashingMachine', label: 'Wasmachine', Icon: WashingMachine },
  { value: 'Lockers', label: 'Lockers/Kasten', Icon: Lockers },
];

// ── Documenten & Data ──

export const DOCUMENTS_ICONS: IconItem[] = [
  { value: 'ClipboardText', label: 'Document', Icon: ClipboardText },
  { value: 'FileText', label: 'Bestand', Icon: FileText },
  { value: 'FileLock', label: 'Beveiligd bestand', Icon: FileLock },
  { value: 'Notebook', label: 'Notitieboek', Icon: Notebook },
  { value: 'Calculator', label: 'Rekenmachine', Icon: Calculator },
  { value: 'ChartLine', label: 'Grafiek lijn', Icon: ChartLine },
  { value: 'ChartBar', label: 'Grafiek staaf', Icon: ChartBar },
  { value: 'Scales', label: 'Weegschaal', Icon: Scales },
  { value: 'TreeStructure', label: 'Structuur', Icon: TreeStructure },
  { value: 'Database', label: 'Database', Icon: Database },
  { value: 'HardDrive', label: 'Opslag', Icon: HardDrive },
  { value: 'HardDrives', label: 'Serveropslag', Icon: HardDrives },
];

// ── Mensen & Communicatie ──

export const PEOPLE_ICONS: IconItem[] = [
  { value: 'Users', label: 'Gebruikers', Icon: Users },
  { value: 'User', label: 'Gebruiker', Icon: User },
  { value: 'Handshake', label: 'Handdruk', Icon: Handshake },
  { value: 'Phone', label: 'Telefoon', Icon: Phone },
  { value: 'PhoneCall', label: 'Telefoongesprek', Icon: PhoneCall },
  { value: 'Envelope', label: 'Email', Icon: Envelope },
  { value: 'ChatCircle', label: 'Chat', Icon: ChatCircle },
  { value: 'Bell', label: 'Bel', Icon: Bell },
  { value: 'BellSimple', label: 'Notificatie', Icon: BellSimple },
  { value: 'BellSlash', label: 'Stil', Icon: BellSlash },
  { value: 'Megaphone', label: 'Megafoon', Icon: Megaphone },
  { value: 'Microphone', label: 'Microfoon', Icon: Microphone },
  { value: 'SpeakerHigh', label: 'Luidspreker', Icon: SpeakerHigh },
  { value: 'CallBell', label: 'Deurbel', Icon: CallBell },
];

// ── Tijd & Planning ──

export const TIME_ICONS: IconItem[] = [
  { value: 'Clock', label: 'Klok', Icon: Clock },
  { value: 'ClockCountdown', label: 'Aftellen', Icon: ClockCountdown },
  { value: 'Calendar', label: 'Kalender', Icon: Calendar },
  { value: 'Hourglass', label: 'Zandloper', Icon: Hourglass },
  { value: 'Timer', label: 'Timer', Icon: Timer },
];

// ── Gezondheid & Medisch ──

export const HEALTH_ICONS: IconItem[] = [
  { value: 'Heartbeat', label: 'Hartslag', Icon: Heartbeat },
  { value: 'Heart', label: 'Hart', Icon: Heart },
  { value: 'Pill', label: 'Pil', Icon: Pill },
  { value: 'Stethoscope', label: 'Stethoscoop', Icon: Stethoscope },
  { value: 'Syringe', label: 'Spuit', Icon: Syringe },
  { value: 'Bandaids', label: 'Pleisters', Icon: Bandaids },
  { value: 'Wheelchair', label: 'Rolstoel', Icon: Wheelchair },
];

// ── Zakelijk & Financieel ──

export const BUSINESS_ICONS: IconItem[] = [
  { value: 'Money', label: 'Geld', Icon: Money },
  { value: 'CurrencyEur', label: 'Euro', Icon: CurrencyEur },
  { value: 'CreditCard', label: 'Creditcard', Icon: CreditCard },
  { value: 'Wallet', label: 'Portemonnee', Icon: Wallet },
  { value: 'PiggyBank', label: 'Spaarpot', Icon: PiggyBank },
  { value: 'Receipt', label: 'Bon', Icon: Receipt },
  { value: 'TrendUp', label: 'Trend omhoog', Icon: TrendUp },
  { value: 'Percent', label: 'Procent', Icon: Percent },
];

// ── Apparaten & IT ──

export const DEVICES_ICONS: IconItem[] = [
  { value: 'Desktop', label: 'Computer', Icon: Desktop },
  { value: 'DesktopTower', label: 'Desktop PC', Icon: DesktopTower },
  { value: 'ComputerTower', label: 'Servertoren', Icon: ComputerTower },
  { value: 'Monitor', label: 'Beeldscherm', Icon: Monitor },
  { value: 'Printer', label: 'Printer', Icon: Printer },
  { value: 'DeviceMobile', label: 'Smartphone', Icon: DeviceMobile },
  { value: 'DeviceTablet', label: 'Tablet', Icon: DeviceTablet },
  { value: 'Keyboard', label: 'Toetsenbord', Icon: Keyboard },
  { value: 'Mouse', label: 'Muis', Icon: Mouse },
  { value: 'Bluetooth', label: 'Bluetooth', Icon: Bluetooth },
  { value: 'Cpu', label: 'Processor', Icon: Cpu },
  { value: 'HardDrive', label: 'Harde schijf', Icon: HardDrive },
  { value: 'HardDrives', label: 'NAS/Server', Icon: HardDrives },
];

// ── Transport & Vervoer ──

export const TRANSPORT_ICONS: IconItem[] = [
  { value: 'Car', label: 'Auto', Icon: Car },
  { value: 'Truck', label: 'Vrachtwagen', Icon: Truck },
  { value: 'Bicycle', label: 'Fiets', Icon: Bicycle },
  { value: 'Train', label: 'Trein', Icon: Train },
  { value: 'Airplane', label: 'Vliegtuig', Icon: Airplane },
  { value: 'Boat', label: 'Boot', Icon: Boat },
  { value: 'Motorcycle', label: 'Motorfiets', Icon: Motorcycle },
  { value: 'FireTruck', label: 'Brandweerwagen', Icon: FireTruck },
];

// ── Overig ──

export const MISC_ICONS: IconItem[] = [
  { value: 'Star', label: 'Ster', Icon: Star },
  { value: 'Flag', label: 'Vlag', Icon: Flag },
  { value: 'Trophy', label: 'Trofee', Icon: Trophy },
  { value: 'Target', label: 'Doel', Icon: Target },
  { value: 'PuzzlePiece', label: 'Puzzel', Icon: PuzzlePiece },
  { value: 'Tag', label: 'Tag', Icon: Tag },
  { value: 'Bookmark', label: 'Bladwijzer', Icon: Bookmark },
  { value: 'Archive', label: 'Archief', Icon: Archive },
  { value: 'Package', label: 'Pakket', Icon: Package },
  { value: 'Gift', label: 'Cadeau', Icon: Gift },
  { value: 'Barcode', label: 'Barcode', Icon: Barcode },
  { value: 'QrCode', label: 'QR Code', Icon: QrCode },
  { value: 'Check', label: 'Vinkje', Icon: Check },
  { value: 'X', label: 'Kruis', Icon: X },
  { value: 'Info', label: 'Info', Icon: Info },
  { value: 'Tray', label: 'Lade', Icon: Tray },
  { value: 'Funnel', label: 'Trechter/Filter', Icon: Funnel },
  { value: 'Camera', label: 'Camera', Icon: Camera },
  { value: 'MusicNote', label: 'Muziek', Icon: MusicNote },
  { value: 'Headphones', label: 'Koptelefoon', Icon: Headphones },
  { value: 'Television', label: 'Televisie', Icon: Television },
  { value: 'GameController', label: 'Controller', Icon: GameController },
  { value: 'Atom', label: 'Atoom', Icon: Atom },
  { value: 'Flask', label: 'Kolf', Icon: Flask },
  { value: 'TestTube', label: 'Reageerbuis', Icon: TestTube },
  { value: 'Microscope', label: 'Microscoop', Icon: Microscope },
  { value: 'GraduationCap', label: 'Diploma', Icon: GraduationCap },
  { value: 'BookOpen', label: 'Boek', Icon: BookOpen },
  { value: 'Mailbox', label: 'Brievenbus', Icon: Mailbox },
  { value: 'SquaresFour', label: 'Raster', Icon: SquaresFour },
];

export const ICON_CATEGORIES: IconCategory[] = [
  { key: 'assets', label: 'Voorzieningen & Toestellen', icons: ASSET_ICONS },
  { key: 'real_estate', label: 'Vastgoed & Locaties', icons: REAL_ESTATE_ICONS },
  { key: 'technical', label: 'Technisch & Installaties', icons: TECHNICAL_ICONS },
  { key: 'safety', label: 'Veiligheid & Beveiliging', icons: SAFETY_ICONS },
  { key: 'environment', label: 'Milieu & Natuur', icons: ENVIRONMENT_ICONS },
  { key: 'tools', label: 'Gereedschap & Onderhoud', icons: TOOLS_ICONS },
  { key: 'interior', label: 'Interieur & Meubelen', icons: INTERIOR_ICONS },
  { key: 'documents', label: 'Documenten & Data', icons: DOCUMENTS_ICONS },
  { key: 'people', label: 'Mensen & Communicatie', icons: PEOPLE_ICONS },
  { key: 'time', label: 'Tijd & Planning', icons: TIME_ICONS },
  { key: 'health', label: 'Gezondheid & Medisch', icons: HEALTH_ICONS },
  { key: 'business', label: 'Zakelijk & Financieel', icons: BUSINESS_ICONS },
  { key: 'devices', label: 'Apparaten & IT', icons: DEVICES_ICONS },
  { key: 'transport', label: 'Transport & Vervoer', icons: TRANSPORT_ICONS },
  { key: 'misc', label: 'Overig', icons: MISC_ICONS },
];

export const ALL_ICONS: IconItem[] = ICON_CATEGORIES.flatMap((cat) => cat.icons);

// Deduplicate by value (some icons appear in multiple categories)
const seenValues = new Set<string>();
export const ALL_ICONS_UNIQUE: IconItem[] = ALL_ICONS.filter((icon) => {
  if (seenValues.has(icon.value)) return false;
  seenValues.add(icon.value);
  return true;
});

/** Resolve an icon value string to its Phosphor Icon component */
export const getIconByValue = (value: string): PhosphorIcon | null => {
  const found = ALL_ICONS.find((i) => i.value === value);
  return found?.Icon ?? null;
};
